export default __webpack_public_path__ + "static/office1-3x-999a445b7ab988f35349fea73338f52f.jpg";